<template>
  <div class="custom-dropdown col-12 " ref="root">
    <div class="dropdown-control" @click="toggle">
      <span class="dropdown-placeholder">
        {{ displayValue }}
      </span>
      <span class="dropdown-arrow " :class="{ open: isOpen }"></span>
    </div>
    <transition name="dropdown">
      <div v-if="isOpen" class="dropdown-menu" ref="dropdownMenu">
        <input
            ref="search"
            v-model="filterText"
            type="text"
            class="dropdown-search"
            placeholder="Поиск..."
            @click.stop
        />
        <ul class="dropdown-list">
          <li
              v-for="(opt, index) in filtered"
              :key="index"
              class="dropdown-item"
              :class="{ selected: isSelected(opt) }"
              @click="showAddButton ? null : onSelect(opt)"
          >
            <div class="dropdown-text">
              <span v-if="getIdentifier(opt)" class="fkko-code">{{ getIdentifier(opt) }}</span>
              <span class="waste-name">{{ getOptionText(opt) }}</span>
              <span v-if="getAdditionalInfo(opt)" class="additional-info">{{ getAdditionalInfo(opt) }}</span>
            </div>
            <button v-if="showAddButton" class="btn-primary waste-add-btn" @click.stop="onAdd(opt)">Добавить</button>
          </li>

          <li v-if="!filtered.length" class="dropdown-item no-results">
            Ничего не найдено
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "CustomDropdown",
  props: {
    options: { type: Array, required: true },
    placeholder: { type: String, default: "Выберите" },
    value: { default: null },
    closeOnAdd: { type: Boolean, default: false },
    showAddButton: { type: Boolean, default: true }
  },
  data() {
    return {
      isOpen: false,
      filterText: "",
      localSelected: this.value
    };
  },
  mounted() {
    document.addEventListener('click', this.onGlobalClick, true);
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.onGlobalClick, true);
    document.removeEventListener('keydown', this.onKeydown);
  },
  computed: {
    filtered() {
      if (!this.options) return [];
      const term = this.filterText.toLowerCase().trim();
      return term
          ? this.options.filter(opt => {
              const text = this.getOptionText(opt).toLowerCase();
              const identifier = this.getIdentifier(opt).toLowerCase();
              const additional = this.getAdditionalInfo(opt).toLowerCase();
              return text.includes(term) || identifier.includes(term) || additional.includes(term);
            })
          : this.options;
    },
    displayValue() {
      if (!this.localSelected) return this.placeholder;
      const identifier = this.getIdentifier(this.localSelected);
      const text = this.getOptionText(this.localSelected);
      const additional = this.getAdditionalInfo(this.localSelected);
      if (identifier && !text) {
        return additional ? `${identifier}, ${additional}` : identifier;
      }
      if (identifier && text) {
        return `${identifier} ${text}`;
      }
      return text || this.placeholder;
    }
  },
  watch: {
    value(newVal) {
      this.localSelected = newVal;
    }
  },
  methods: {
    getOptionText(opt) {
      if (typeof opt === 'string') return opt;

      const name =
          opt.Name ||
          opt.name ||
          opt.WasteName ||
          opt.wasteName ||
          opt.label ||
          opt.text ||
          '';

      if (!name && this.getIdentifier(opt)) {
        return '[Название не указано]';
      }

      return name;
    },
    getIdentifier(opt) {
      if (typeof opt === 'string') return '';
      if (opt.ContractID && opt.Amount !== undefined && !opt.Name && !opt.FKKO) {
        return opt.ContractID;
      }
      const code = opt.FKKO || opt.fkko || opt.FKKOCode || opt.fkkoCode || opt.code || opt.Code || '';
      const trimmed = typeof code === 'string' ? code.trim() : String(code);
      return (trimmed && trimmed !== '0') ? trimmed : '';
    },
    getAdditionalInfo(opt) {
      if (typeof opt === 'string') return '';
      if (opt.ContractID && opt.Amount !== undefined && !opt.Name && !opt.FKKO) {
        return `остаток: ${opt.Amount}`;
      }

      return '';
    },
    getFKKOCode(opt) {
      return this.getIdentifier(opt);
    },
    isSelected(opt) {
      if (!this.localSelected) return false;
      if (typeof opt === 'object' && typeof this.localSelected === 'object') {
        return JSON.stringify(opt) === JSON.stringify(this.localSelected);
      }
      return opt === this.localSelected;
    },

    onGlobalClick(e) {
      if (!this.isOpen) return;
      const root = this.$refs.root;
      if (root && !root.contains(e.target)) {
        this.isOpen = false;
      }
    },
    onKeydown(e) {
      if (!this.isOpen) return;
      if (e.key === 'Escape' || e.key === 'Tab') {
        this.isOpen = false;
      }
    },

    toggle() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.filterText = "";
        this.$nextTick(() => this.$refs.search?.focus());
      }
    },
    onSelect(opt) {
      this.localSelected = opt;
      this.$emit('input', opt);
      this.$emit('select', opt);
      this.isOpen = false;
    },
    onAdd(opt) {
      let cleanedOption;

      if (typeof opt === 'string') {
        // Если это строка, удаляем цифры в начале
        const cleanedName = opt.replace(/^\d+\s+/, '').trim();
        cleanedOption = cleanedName;
      } else {
        // Если это объект, очищаем текст от цифр в начале
        const originalName = this.getOptionText(opt);
        const cleanedName = originalName.replace(/^\d+\s+/, '').trim();
        cleanedOption = {
          ...opt,
          Name: cleanedName,
          name: cleanedName,
          WasteName: cleanedName
        };
      }

      this.$emit('select', cleanedOption);
      this.$emit('add', cleanedOption);
      if (this.closeOnAdd) this.isOpen = false;
      this.$nextTick(() => this.$refs.search?.focus());
    }
  }
};
</script>


<style scoped>
.waste-add-btn {
  flex-shrink: 0;
  height: 32px;
  padding: 0 12px;
  border-radius: 4px;
  background-color: #409eff;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  transition: background-color 0.2s ease;
  pointer-events: auto;
  position: relative;
  z-index: 10;
}

.waste-add-btn:hover {
  background-color: #66b1ff;
}
.custom-dropdown {
  position: relative;
  width: 100%;
  max-width: 90%;
  font-family: inherit;
  font-size: 16px;
}

.dropdown-control {
  display: flex;
  justify-content: space-between;
  padding: 14px 24px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  cursor: pointer;
  background: #fff;
  transition: all 0.3s ease;
  align-items: center;
  min-height: 52px;
  width: 100%;
  font-size: 18px;
}

.dropdown-control:hover {
  border-color: #c0c4cc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.dropdown-menu {
  position: absolute;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  z-index: 1001;
  margin-top: 8px;
  width: 100%;
  max-height: 500px;
  overflow: hidden;
  box-sizing: border-box;
}

.dropdown-search {
  width: 90%;
  padding: 14px 16px;
  margin: 12px 16px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  outline: none;
  font-size: 18px;
  transition: all 0.3s;
}

.dropdown-search:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.2);
}

.dropdown-placeholder {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  color: #606266;
}

.dropdown-text {
  flex: 1;
  margin-right: 12px;
  pointer-events: none;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.fkko-code {
  color: #909399;
  font-size: 14px;
  margin-right: 8px;
  font-weight: normal;
}

.waste-name {
  color: #606266;
  font-size: 16px;
}

.additional-info {
  color: #909399;
  font-size: 14px;
  margin-left: 8px;
  font-style: italic;
}

.dropdown-arrow {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #909399;
  margin-left: 16px;
  transition: transform 0.3s;
  flex-shrink: 0;
}

.dropdown-arrow.open {
  transform: rotate(180deg);
}

.dropdown-list {
  max-height: 400px;
  margin: 0;
  padding: 12px 0;
  list-style: none;
  overflow-y: auto;
}

.dropdown-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 20px;
  cursor: pointer;
  color: #606266;
  white-space: normal;
  word-break: break-word;
  line-height: 1.6;
  transition: all 0.2s;
  font-size: 17px;
}

.dropdown-item:hover {
  background-color: #f5f7fa;
  color: #409eff;
}

.dropdown-item.selected {
  color: #409eff;
  background-color: #ecf5ff;
  font-weight: 500;
}

.no-results {
  color: #909399;
  font-style: italic;
  cursor: default;
  justify-content: center;
  padding: 24px;
  font-size: 18px;
}

.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.3s ease;
}

.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}
</style>